import { PageHero, SHELL, Reveal, Mono, StatusBadge } from "@/components/bits";
import { CONTRACT_CONCEPTS } from "@/lib/data";

const MODULES = ["ASSET REGISTRY", "POOL ENGINE", "VAULT ENGINE", "ACCOUNTING", "VERIFICATION", "CREDIT ENGINE", "SETTLEMENT"];

export default function Architecture() {
    return (
        <div data-testid="architecture-page">
            <PageHero
                label="PROTOCOL ARCHITECTURE"
                title={"UNDER THE SURFACE"}
                sub="Coordinated systems — registry, pools, vaults, accounting, verification, credit and settlement — layered over USDC and Arc."
            />
            <section className="py-20 md:py-28">
                <SHELL>
                    <Reveal>
                        <div className="glass-card p-8 md:p-12 mb-16" data-testid="architecture-layer-diagram">
                            <Mono className="text-vera-gold2 block mb-10 text-center">THE LAYER MAP</Mono>
                            <div className="max-w-3xl mx-auto">
                                <div className="flex justify-center">
                                    <div className="px-8 py-4 border border-vera-gold/60 text-vera-gold2 bg-vera-gold/10 font-mono text-xs tracking-[0.3em]">VERA</div>
                                </div>
                                <div className="w-px h-8 bg-white/15 mx-auto" aria-hidden="true" />
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                                    {MODULES.map((m) => (
                                        <div key={m} className="px-4 py-4 border border-vera-blue/35 bg-vera-deep/60 font-mono text-[9px] tracking-[0.2em] text-[#A8D2FF] text-center">
                                            {m}
                                        </div>
                                    ))}
                                </div>
                                <div className="w-px h-8 bg-white/15 mx-auto mt-0" aria-hidden="true" />
                                <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6">
                                    <div className="px-8 py-4 border border-vera-blue/50 text-[#A8D2FF] bg-vera-blue/10 font-mono text-xs tracking-[0.3em]">USDC</div>
                                    <span className="font-mono text-vera-mut/50 rotate-90 md:rotate-0" aria-hidden="true">→</span>
                                    <div className="px-8 py-4 border border-vera-blue/50 text-[#A8D2FF] bg-vera-blue/10 font-mono text-xs tracking-[0.3em]">ARC</div>
                                </div>
                            </div>
                        </div>
                    </Reveal>

                    <div className="grid lg:grid-cols-[1fr_320px] gap-10 items-start">
                        <Reveal>
                            <div className="flex items-center justify-between flex-wrap gap-4 mb-8">
                                <Mono className="text-vera-mut">CONCEPTUAL CONTRACT COMPONENTS</Mono>
                                <StatusBadge status="DEMO" className="!text-vera-mut" />
                            </div>
                            <div className="border border-white/10" data-testid="architecture-contracts-table">
                                {CONTRACT_CONCEPTS.map((c, i) => (
                                    <div key={c.name} className={`flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-6 px-6 py-4 ${i < CONTRACT_CONCEPTS.length - 1 ? "border-b border-white/5" : ""} hover:bg-white/[0.02] transition-colors`} data-testid={`contract-concept-${c.name.toLowerCase()}`}>
                                        <span className="font-mono text-xs text-vera-gold2 w-44 shrink-0">{c.name}</span>
                                        <span className="text-sm text-vera-mut">{c.role}</span>
                                    </div>
                                ))}
                            </div>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <div className="border border-dashed border-vera-gold/40 bg-vera-gold/5 p-7">
                                <p className="font-mono text-[10px] tracking-[0.25em] text-vera-gold2 mb-4">STATUS OF THIS PAGE</p>
                                <p className="text-sm text-vera-mut leading-relaxed mb-4">
                                    These are architectural concepts. No contract is claimed as deployed, and no address is published, until real
                                    deployments exist and are confirmed in the Proof Center.
                                </p>
                                <p className="text-sm text-vera-mut leading-relaxed">
                                    All future contract addresses enter through environment configuration — never hardcoded, never invented.
                                </p>
                            </div>
                        </Reveal>
                    </div>
                </SHELL>
            </section>
        </div>
    );
}
